import { css } from '@styled-system/css';
import { Search, X } from 'lucide-react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Input } from './Input';

// Barre de recherche des toolbars — même gabarit que les autres contrôles DS
// (Dropdown, Button « Filtres ») : 32px de haut, bordure strong, radius md.
// Remplace l'ancien antd Input.Search v1 (dont le bouton loupe débordait).

const clearButton = css({
  display: 'inline-flex',
  alignItems: 'center',
  background: 'transparent',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  color: 'text.tertiary',
  _hover: { color: 'text.primary' },
});

export interface SearchBarNewProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export const SearchBarNew: FC<SearchBarNewProps> = ({ placeholder, value, onChange, className }) => {
  const { t } = useTranslation();
  return (
    <div className={`${css({ w: '245px' })} ${className || ''}`}>
      <Input
        inputSize="md"
        leading={<Search size={13} strokeWidth={1.75} />}
        trailing={
          value ? (
            <button type="button" className={clearButton} onClick={() => onChange('')} aria-label={t('ui.clear')}>
              <X size={13} strokeWidth={1.75} />
            </button>
          ) : undefined
        }
        placeholder={placeholder ?? t('ui.searchPlaceholder')}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  );
};
